import React, { useContext, useMemo } from 'react';
import { TSelectedDetail } from '../../../Types/MasterDetailTypes';

export interface IMdDetailSelectionContext {
  selectedDetail?: TSelectedDetail;
  unselectDetail?: () => void;
  selectDetail?: (id: TSelectedDetail, force?: boolean) => void;
  selectNextDetail?: (force?: boolean) => void;
  selectPreviousDetail?: () => void;
  currentItem: number | undefined;
  totalItems: number | undefined;
  indexCaption: string;
}

export const MdDetailSelectionContext =
  React.createContext<IMdDetailSelectionContext>({
    selectedDetail: null,
    unselectDetail: () => {},
    selectDetail: () => {},
    selectNextDetail: undefined,
    selectPreviousDetail: undefined,
    currentItem: undefined,
    totalItems: undefined,
    indexCaption: '',
  });

export const useMDDetailSelectionContext = () =>
  useContext(MdDetailSelectionContext);

export const MdDetailSelectionContextProvider: React.FC<
  React.PropsWithChildren<IMdDetailSelectionContext>
> = props => {
  const mdDetailSelectionContextValue = useMemo<IMdDetailSelectionContext>(
    () => ({
      selectedDetail: props.selectedDetail,
      unselectDetail: props.unselectDetail,
      selectDetail: props.selectDetail,
      selectNextDetail: props.selectNextDetail,
      selectPreviousDetail: props.selectPreviousDetail,
      currentItem: props.currentItem,
      totalItems: props.totalItems,
      indexCaption: props.indexCaption,
    }),
    [
      props.selectedDetail,
      props.unselectDetail,
      props.selectDetail,
      props.selectNextDetail,
      props.selectPreviousDetail,
      props.currentItem,
      props.totalItems,
      props.indexCaption,
    ]
  );

  return (
    <MdDetailSelectionContext.Provider value={mdDetailSelectionContextValue}>
      {props.children}
    </MdDetailSelectionContext.Provider>
  );
};
